<template>
  <div class="fixed-bar">
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      right
      class="custom-hidden-md-and-up fixed--bar-mobile"
    >
      <v-list nav dense class="fixed--bar-mobile">
        <v-list-item-group v-model="group">
          <template v-for="(item, i) in mobileItems">
          <v-subheader v-if="item.isGroup" :key="'g' + i" class="menu-group-title">{{ item.title }}</v-subheader>
          <v-list-item 
            v-else
            :key="i" 
            :class="{ 'menu-group-child': item.inGroup, 'menu-highlight-item': item.highlight }"
            v-bind="getHeader.length
              ? { to: item.route }
              : { href: item.route }"
          >
            <v-list-item-icon>
              <v-icon :color="item.highlight ? '#FFFFFF' : undefined">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title :class="{ 'menu-highlight': item.highlight }">
              {{ item.shortTitle || item.title }}<span v-if="item.badge" class="menu-badge">{{ item.badge }}</span>
            </v-list-item-title>
          </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar light max-height="70px" class="fixed-bar cabinet-header">
      <v-col lg="10" offset-lg="1" class="d-flex header__wrapper">
        <v-toolbar-title class="align-self-center"></v-toolbar-title>

        <a class="logo-link" @click="goToMainPage">
          <img
            class="logo"
            src="../../../public/platformaIcon.png"
            alt="Платформа"
          />
          <!-- registered trade mark next to the logo -->
          <span class="logo-reg">®</span>
        </a>

        <v-spacer></v-spacer>
        <v-toolbar-items class="custom-hidden-sm-and-down">
          <v-tabs color="primary" background-color="transparent" :class="{ 'menu-in-group': inGroup }">
            <template v-for="(item, i) in getHeader">
            <v-menu v-if="item.children" :key="'g' + i" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-tab class="menu-group" :class="{ 'menu-group--active': groupActive(item) }" v-bind="attrs" v-on="on" @click.prevent>
                  {{ item.title }}<v-icon small class="ml-1">mdi-chevron-down</v-icon>
                </v-tab>
              </template>
              <v-list dense class="menu-group-list">
                <v-list-item v-for="child in item.children" :key="child.route" :to="child.route">
                  <v-list-item-title>{{ child.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-tab v-else :key="i" :to="item.route" :class="{ 'menu-highlight': item.highlight }">
              <v-icon :color="item.highlight ? '#FFFFFF' : undefined" :class="{ 'mr-1': item.highlight }">{{ item.icon }}</v-icon>
              {{ item.shortTitle || item.title }}<span v-if="item.badge" class="menu-badge">{{ item.badge }}</span>
            </v-tab>
            </template>
          </v-tabs>
        </v-toolbar-items>
        <v-btn
          v-if="isAuthCheck()"
          text
          class="align-self-center cabinet-header__exit"
          @click="logout"
        >
          <span class="cabinet-header__exit-text">{{ $vuetify.lang.t("$vuetify.main.header.menu.exit") }}</span>
          <v-icon color="primary">mdi-logout</v-icon></v-btn
        >
        <v-app-bar-nav-icon
          @click.stop="drawer = !drawer"
          class="custom-hidden-md-and-up"
        ></v-app-bar-nav-icon>
      </v-col>
    </v-toolbar>
  </div>
</template>

<script>
import router from "../../router";
import Vue from "vue";
import { mapGetters } from "vuex";
import ApiClient from "@/libs/http-client";

export default {
  name: "headerComponent",
  data() {
    return {
      linkToMainPage: process.env.VUE_APP_MAIN_PAGE,
      headerTitle: "Платформа",
      drawer: false,
      group: null,
      logoImg: "../../../../public/logo.png",
      unreadQuestions: 0,
      unreadGuide: 0,
      unreadForum: 0,
      unreadChat: 0,
      chatTimer: null,
    };
  },
  watch: {
    // new answers / updates are re-counted on every page change and when a page asks for it
    $route() {
      this.loadCounters();
    },
    "getUser.role"() {
      this.loadCounters();
    },
  },
  mounted() {
    this.loadCounters();
    this.$root.$on("menu-counters-refresh", this.loadCounters);
    // new chat messages show up in the menu without reloading the page
    this.chatTimer = setInterval(() => {
      if (!document.hidden) this.loadChatCounter();
    }, 30000);
  },
  beforeDestroy() {
    this.$root.$off("menu-counters-refresh", this.loadCounters);
    clearInterval(this.chatTimer);
  },
  methods: {
    groupActive(item) {
      return item.children.some((child) => this.$route.path.startsWith(child.route));
    },
    loadChatCounter() {
      if (!this.isAuthCheck() || !["patient", "psychologist"].includes(this.getUser.role)) return;
      ApiClient.get("api/chat/unread")
        .then((response) => {
          this.unreadChat = (response && response.data && response.data.data && response.data.data.count) || 0;
        })
        .catch(() => {});
    },
    loadCounters() {
      if (!this.isAuthCheck()) return;
      this.loadChatCounter();
      const role = this.getUser.role;
      // psychologist: clients' clarifying questions under my forum answers
      if (role === "psychologist") {
        ApiClient.get("api/psychologists/me/forum/unread")
          .then((response) => {
            this.unreadForum = (response && response.data && response.data.data && response.data.data.count) || 0;
          })
          .catch(() => {});
      }
      const url = role === "patient"
        ? "api/patients/forum/my-questions/unread"
        : role === "psychologist" ? "api/psychologists/me/guide/unread" : null;
      if (!url) return;
      ApiClient.get(url)
        .then((response) => {
          const count = (response && response.data && response.data.data && response.data.data.count) || 0;
          if (role === "patient") this.unreadQuestions = count;
          else this.unreadGuide = count;
        })
        .catch(() => {});
    },
    goToMainPage() {
      location.href = this.linkToMainPage;
    },
    isAuthCheck() {
      return this.$store.getters["user/isAuth"];
    },
    logout() {
      this.$store.commit("app/CHANGE_LOCALE", "uk");
      this.$store.commit("user/SET_LOGOUT");
      router.push("/auth");
      Vue.swal({
        target: document.getElementById("main"),
        text: this.$vuetify.lang.t("$vuetify.view.auth.logout"),
        icon: "success",
        timer: 3500,
        toast: true,
        position: "top-right",
        showConfirmButton: false,
      });
    },
  },
  computed: {
    ...mapGetters({
      getUser: 'user/getUser'
    }),
    getUserRolePatientOrFalse: function () {
      return this.$store.getters["user/getUser"].role === "psychologist";
    },
    getMobileMenu: function () {
      return [
        {
          title: this.$vuetify.lang.t('$vuetify.main.header.menuItem1'),
          route: process.env.VUE_APP_MAIN_PAGE + '/about',
          icon: ''
        },
        {
          title: this.$vuetify.lang.t('$vuetify.main.header.menu.ourPsychologists'),
          route: process.env.VUE_APP_MAIN_PAGE + '/therapists',
          icon: ''
        },
        {
          title: this.$vuetify.lang.t('$vuetify.main.header.menuItem3'),
          route: process.env.VUE_APP_MAIN_PAGE + '/psychologist',
          icon: ''
        },
        {
          title: 'Заходи',
          route: process.env.VUE_APP_MAIN_PAGE + '/events',
          icon: ''
        },
        {
          title: this.$vuetify.lang.t('$vuetify.main.header.menuItem4'),
          route: process.env.VUE_APP_MAIN_PAGE + '/blog',
          icon: ''
        },
        {
          title: 'Форум',
          route: process.env.VUE_APP_MAIN_PAGE + '/forum',
          icon: ''
        },
        {
          title: this.$vuetify.lang.t('$vuetify.main.header.menuItem5'),
          route: process.env.VUE_APP_MAIN_PAGE + '/business',
          icon: ''
        },
        {
          title: this.$vuetify.lang.t('$vuetify.main.header.EnterButton'),
          route: '',
          icon: 'mdi-lock',
          routeToDashboard: '/auth'
        }
      ]
    },
    // the open page belongs to a group of the menu: the group is underlined instead of a tab
    inGroup() {
      return Array.isArray(this.getHeader) && this.getHeader.some((item) => item.children && this.groupActive(item));
    },
    // the drawer lists a group as its heading and its pages
    mobileItems() {
      if (!Array.isArray(this.getHeader) || !this.getHeader.length) return this.getMobileMenu;
      return this.getHeader.flatMap((item) => (item.children
        ? [{ title: item.title, isGroup: true }, ...item.children.map((child) => ({ ...child, inGroup: true }))]
        : [item]));
    },
    getHeader: function () {
      let user = this.getUser;
      let userRole = this.getUser.role;
      if (userRole && userRole !== "admin" && userRole !== "redactor" && (user.login_provider === undefined || user.login_provider === null) && (user.phone_country_code !== "UA" || this.$store.getters["settings/requireProviderAfterSms"])) {
        userRole = "needs_linking_login";
      }
      switch (userRole) {
        case "patient":
          return this.patientMenu;
        case "admin":
          return this.adminMenu;
        case "psychologist":
          return this.psychologistMenu;
        case "redactor":
          return this.redactorMenu;
        case "needs_linking_login":
          return [
            {
              title: this.$vuetify.lang.t('$vuetify.view.signIn.oldLoginLink1'),
              route: process.env.VUE_APP_MAIN_PAGE + '/linking-login',
              icon: ''
            },
          ];
        default:
          return {};
      }
    },
    redactorMenu() {
      return [
        // {
        //   title: this.$vuetify.lang.t("$vuetify.main.header.menu.main"),
        //   route: "/dashboard/main",
        // },
        {
          title: this.$vuetify.lang.t("$vuetify.main.header.menu.blog"),
          route: "/dashboard/blog",
        },
        {
          title: "Заходи",
          route: "/dashboard/events",
        },
        {
          title: "Тести",
          route: "/dashboard/tests-admin",
        },
        {
          title: this.$vuetify.lang.t("$vuetify.main.header.menu.categories"),
          route: "/dashboard/categories",
        },
      ];
    },
    // grouped by the customer's list of 19.10: a group opens its pages in a dropdown
    adminMenu() {
      return [
        {
          title: "CRM",
          route: "/dashboard/crm",
        },
        {
          title: "Матеріали",
          children: [
            { title: "Заходи", route: "/dashboard/events" },
            { title: "Форум", route: "/dashboard/forum-admin" },
            { title: "Тести", route: "/dashboard/tests-admin" },
            { title: "ШІ-агент", route: "/dashboard/ai-agent" },
            { title: "Інструкція", route: "/dashboard/guide-admin" },
          ],
        },
        {
          title: this.$vuetify.lang.t("$vuetify.main.header.menu.blog"),
          children: [
            { title: "Статті", route: "/dashboard/blog" },
            { title: "Редактори", route: "/dashboard/redactors" },
            { title: this.$vuetify.lang.t("$vuetify.main.header.menu.categories"), route: "/dashboard/categories" },
          ],
        },
        {
          title: this.$vuetify.lang.t("$vuetify.main.header.menu.psychologists"),
          route: "/dashboard/psychologists",
        },
      ];
    },
    patientMenu() {
      return [
        {
          title: this.$vuetify.lang.t("$vuetify.main.header.menu.settings"),
          route: "/dashboard/settings",
        },
        {
          title: this.$vuetify.lang.t("$vuetify.main.header.menu.psychologists"),
          route: "/dashboard/psychologist",
        },
        {
          title: this.$vuetify.lang.t("$vuetify.main.header.menu.favorites"),
          route: "/dashboard/favorites",
        },
        {
          title: "Чат",
          route: "/dashboard/chat",
          badge: this.unreadChat,
        },
        {
          title: this.$vuetify.lang.t("$vuetify.main.header.menu.myQuestions"),
          route: "/dashboard/my-questions",
          badge: this.unreadQuestions,
        },
        {
          title: "Мої тести",
          route: "/dashboard/my-tests",
        },
        {
          title: this.$vuetify.lang.t("$vuetify.main.header.menu.help"),
          route: "/help",
        },
      ];
    },
    psychologistMenu() {
      return [
        {
          title: this.$vuetify.lang.t("$vuetify.main.header.menu.cabinet"),
          route: "/dashboard/main",
        },
        // {
        //   title: this.$vuetify.lang.t("$vuetify.main.header.menu.blog"),
        //   route: "/dashboard/blog",
        // },
        {
          title: this.$vuetify.lang.t("$vuetify.main.header.menu.settings"),
          route: "/dashboard/settings",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.main.header.menu.specialization"
          ),
          route: "/dashboard/specialization",
        },
        {
          title: this.$vuetify.lang.t("$vuetify.main.header.menu.schedule"),
          route: "/dashboard/schedule",
        },
        {
          title: "Чат",
          route: "/dashboard/chat",
          badge: this.unreadChat,
        },
        {
          title: "Форум",
          route: "/dashboard/forum",
          badge: this.unreadForum,
        },
        {
          title: this.$vuetify.lang.t("$vuetify.main.header.menu.guide"),
          shortTitle: this.$vuetify.lang.t("$vuetify.main.header.menu.guideShort"),
          route: "/dashboard/guide",
          icon: "mdi-book-open-page-variant-outline",
          highlight: true,
          badge: this.unreadGuide,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 1480px) and (min-width: 1264px) {
  .header__wrapper {
    max-width: 1185px;
    flex: auto;
    margin: 0 auto;
  }
}
@media (min-width: 1000px) {
  .custom-hidden-md-and-up {
    display: none !important;
  }
}
@media (max-width: 999px) {
  .custom-hidden-sm-and-down {
    display: none !important;
  }
}
</style>
<style lang="scss" scoped>
.cabinet-header.v-toolbar {
  background-color: #D9E4EB !important;
  box-shadow: none !important;
}
.cabinet-header ::v-deep .v-tab {
  padding: 0 14px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: normal;
  text-transform: none;
  color: #575756 !important;
}
.cabinet-header ::v-deep .v-tab:not(:last-child)::after {
  content: "•";
  position: absolute;
  right: -3px;
  font-size: 12px;
  color: #575756;
}
.cabinet-header ::v-deep .v-tab--active {
  color: #575756 !important;
}
.cabinet-header ::v-deep .v-tabs-slider-wrapper {
  height: 2px !important;
}
@media (max-width: 600px) {
  .cabinet-header__exit-text {
    display: none;
  }
  .cabinet-header__exit.v-btn {
    min-width: 0 !important;
    padding: 0 8px !important;
  }
}
/* a long item gets its short name while the menu is tight */
.menu-title-short {
  display: none;
}
@media (max-width: 1439px) {
  .menu-title-full {
    display: none;
  }
  .menu-title-short {
    display: inline;
  }
}
@media (max-width: 1263px) {
  .cabinet-header ::v-deep .v-tab {
    padding: 0 10px;
  }
}
/* tablets: the whole psychologist's menu with "Інструкція" fits next to "Вихід" */
@media (max-width: 1100px) {
  .cabinet-header ::v-deep .v-tab {
    min-width: 0;
    padding: 0 7px;
    font-size: 14px;
  }
  .cabinet-header ::v-deep .v-tab.menu-highlight {
    margin: 0 4px;
    padding: 0 10px;
  }
  .cabinet-header__exit-text {
    display: none;
  }
  .cabinet-header__exit.v-btn {
    min-width: 0 !important;
    padding: 0 8px !important;
  }
}
/* a group of the admin's menu: the open page's group is underlined like an active tab */
.cabinet-header ::v-deep .v-tab.menu-group {
  cursor: pointer;
}
.cabinet-header ::v-deep .menu-in-group .v-tabs-slider-wrapper {
  display: none;
}
.cabinet-header ::v-deep .v-tab.menu-group--active {
  box-shadow: inset 0 -2px 0 #00A3B7;
}
.menu-group-title {
  color: #00A3B7 !important;
  font-weight: 500;
}
.menu-group-child {
  padding-left: 24px !important;
}
/* counter of new answers / updates next to a menu item */
.menu-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-left: 6px;
  padding: 0 5px;
  border-radius: 9px;
  background: #E5484D;
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
}
/* "Інструкція" stands out in the psychologist's menu */
/* "Інструкція" is a filled button in the psychologist's menu (customer 20.10: psychologists do not notice it) */
.cabinet-header ::v-deep .v-tab.menu-highlight {
  align-self: center;
  height: 38px;
  margin: 0 8px;
  padding: 0 16px;
  border-radius: 6px;
  background: #00A3B7;
  color: #FFFFFF !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 12px rgba(0, 163, 183, 0.35);
  transition: background 0.2s, box-shadow 0.2s;
}
.cabinet-header ::v-deep .v-tab.menu-highlight:hover {
  background: #008C9E;
  box-shadow: 0 6px 16px rgba(0, 163, 183, 0.45);
}
.cabinet-header ::v-deep .v-tab.menu-highlight::before {
  display: none;
}
.cabinet-header ::v-deep .v-tab.menu-highlight::after {
  right: -11px;
}
.menu-highlight-item {
  background: #00A3B7;
}
.menu-highlight-item .menu-highlight,
.menu-highlight {
  color: #FFFFFF !important;
  font-weight: 600 !important;
}
/* a long menu shrinks and scrolls with the arrows, "Вихід" always stays on the screen */
.cabinet-header .header__wrapper {
  min-width: 0;
}
.cabinet-header ::v-deep .v-toolbar__items {
  flex: 0 1 auto;
  min-width: 0;
}
.cabinet-header ::v-deep .v-toolbar__items .v-tabs {
  max-width: 100%;
}
.cabinet-header__exit.v-btn {
  flex-shrink: 0;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: normal;
  text-transform: none;
  color: #575756;
}
</style>
<style lang="sass" scoped>
.logo
  margin-top: 10px
  height: 30px
.logo-link
  display: flex
  align-items: flex-start
  cursor: pointer
.logo-reg
  margin-top: 7px
  margin-left: 2px
  color: #00A3B7
  font-size: 16px
  font-weight: 500
  line-height: 1

.fixed-bar
  position: sticky
  position: -webkit-sticky
  top: 0
  z-index: 5
  // the closed mobile drawer sits off-screen to the right; clip it instead of adding a horizontal scroll
  overflow-x: clip

.fixed--bar-mobile
  position: fixed !important
  z-index: 6
</style>
